import { useEffect, useState } from "react";
import ImageSection from "./ImageSection"
import env from "../../constants/env";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "../Assets/style";
import { Container, SuccessContainer } from "./style";
import { DataSection } from "./DataSection";
import Button from "../../components/Button";
import walletIcon from "../../assets/Wallet_Icon.svg";
import { BodySemibold, Subtitle, SubtitleMedium } from "../../shared/typography";
import { ReactComponent as SuccessIcon } from '../../assets/success_icon.svg'
import { LoadingAnimation } from "../../components/ProcessingModal/Animation";
import { LoaderWrapper } from "../BurnProxyToken/style";
import { addSelectedAssetInfo, openWalletVerify } from "../../redux/walletReducer";
import wallet_yellow_outline from "../../assets/icons/wallet_yellow_outline.svg";
import SecondaryNav from "../../components/Nav/SecondaryNav";

interface IAssetInfo {
    assetChain: string;
    assetWalletAddress: string;
    assetContractAddress: string;
    assetId: string;
    proxy_token_id: string;
    proxy_token_exists: boolean;
}

export const VerifySignature = () => {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let wallet = useSelector((state: RootState) => state.walletState);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [nftData, setNftData] = useState<any>({});
    const [proxyTokenId, setProxyTokenId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [assetInfo, setAssetInfo] = useState<Partial<IAssetInfo>>({});
    const [minterAddress, setMinterAddress] = useState('');

    const [nftMetadata, setNftmetadata] = useState<any>({});


    const fetchNftInfo = async () => {
        try {
            setIsLoading(true)
            const options = {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "X-API-Key": env.MORALIS_API_KEY,
                },
            };
            //   'https://deep-index.moralis.io/api/v2/nft/0x7dE3085b3190B3a787822Ee16F23be010f5F8686/15/metadata?chain=eth' - moralis api structure

            const nftData_ = await axios.get(
                `${env.MORALIS_URL}/api/v2/nft/${assetInfo.assetContractAddress}/${assetInfo.assetId
                }?chain=${assetInfo.assetChain == "ETH" ? env.ETH_CHAIN : env.POLYGON_CHAIN
                }`,
                options
            );

            const tokenData = await axios.get(
                `${env.USER_URL}/proxy-token-mint/proxyToken/${assetInfo?.proxy_token_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${wallet.jwtToken}`,
                    },
                }
            );

            const mintData = await axios.get(
                `${env.USER_URL}/proxy-token-mint/existing?nft_asset_chain=${assetInfo?.assetChain}&nft_asset_contract_address=${assetInfo?.assetContractAddress}&nft_asset_id=${assetInfo?.assetId}`,
                {
                    headers: {
                        Authorization: `Bearer ${wallet.jwtToken}`,
                    },
                }
            );
            const [initializedMintData] = mintData?.data?.filter((el: any) => el?.proxy_token_mint_method === "MESSAGE_SIGNATURE")

            setMinterAddress(initializedMintData?.asset_owner_wallet_address)
            dispatch(
                addSelectedAssetInfo({
                    token_metadata: JSON.parse(nftData_?.data?.metadata),
                    token_id: nftData_?.data?.token_id || '',
                    token_address: assetInfo?.assetContractAddress || '',
                    proxy_token_exists: false,
                })
            );
            setIsVerified(Boolean(tokenData?.data?.admin_tx_signature))
            setNftmetadata(nftData_.data);
            setNftData(JSON.parse(nftData_?.data?.metadata));

        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    };

    const handleSignMessage = async () => {
        setIsLoading(true)
        try {
            const accounts = await window.ethereum.request({ method: 'eth_accounts' })
            if (accounts[0]?.toLowerCase() !== minterAddress?.toLowerCase()) {
                alert("Please use the same account, as used to create the initial transaction")
                return
            }
            const resp = await axios.get(
                `${env.USER_URL}/proxy-token-mint/proxyTokenInitSignatureMessage/${proxyTokenId}`
            )
            const signatureMsg = resp.data
            const signature = await window.ethereum.request({
                method: "personal_sign",
                params: [signatureMsg, accounts[0]],
            });

            await axios.post(
                `${env.USER_URL}/proxy-token-mint/submit-proxy-token-mint-init-signature`,
                {
                    proxy_token_id: proxyTokenId,
                    signature
                },
                {
                    headers: {
                        Authorization: `Bearer ${wallet.jwtToken}`,
                    }
                }
            )
            await fetchNftInfo()
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        const route = window.location.pathname.split("/");
        console.log('wallet..', wallet, wallet.assetAddress, wallet.address == "" ||
            route.length != 7);

        if (
            wallet.address == "" ||
            route.length != 7
        ) {
            return;
        }
        const obj = {
            assetChain: route[2],
            assetWalletAddress: route[3],
            assetContractAddress: route[4],
            assetId: route[5],
            proxy_token_id: route[6],
            proxy_token_exists:
                searchParams.get("proxy_token_exists") == "true" ? true : false
        }
        setProxyTokenId(route[6])
        setAssetInfo(obj)
    }, [wallet.address]);

    useEffect(() => {
        if (assetInfo?.proxy_token_id) fetchNftInfo()
    }, [assetInfo])

    return (
        <Container>
            <SecondaryNav />
            <div className="section">
                {!wallet.address
                    ? <Col justify="space-between" align="center" gap="30px" width="100%">
                        <Col>
                            <SubtitleMedium>Wallet Not Connected</SubtitleMedium>
                            <BodySemibold>Please connect wallet to continue</BodySemibold>
                        </Col>
                        <Button
                            onClick={() => {
                                dispatch(openWalletVerify());
                            }}
                            width="168px"
                            type="BLACK"
                            iconSrc={wallet_yellow_outline}
                        >
                            Connect
                        </Button>
                    </Col>
                    : nftMetadata.metadata ? (
                        <Col>
                            <span className="titleSpan">
                                <h1 className="nameText">
                                    {nftData.name || `${nftMetadata?.name} #${nftMetadata?.token_id}`}
                                </h1>

                                {
                                    nftData.description
                                        ? (
                                            <div className="descriptionText">
                                                {showFullDescription
                                                    ? nftData.description
                                                    : (nftData?.description?.slice(0, 40) + (nftData?.description?.length > 40 ? '...' : ''))
                                                }
                                                <span
                                                    className="viewMoreText"
                                                    onClick={() => setShowFullDescription(!showFullDescription)}
                                                >
                                                    {showFullDescription ? " View Less" : " View More"}
                                                </span>
                                            </div>
                                        )
                                        : <span className="noDescriptionText">No Description</span>
                                }

                            </span>
                            <span className="main">
                                <ImageSection isVerify nftMetadata={nftMetadata} />
                                {
                                    isLoading
                                        ? <Row width="500px" align="center" justify="center">
                                            <LoaderWrapper>
                                                <LoadingAnimation />
                                            </LoaderWrapper>
                                        </Row>
                                        : <Col>
                                            {
                                                isVerified
                                                    ? <SuccessContainer>
                                                        <SuccessIcon />
                                                        <SubtitleMedium>Signature Verified Successfully</SubtitleMedium>
                                                        <Subtitle>You can close this tab</Subtitle>
                                                    </SuccessContainer>
                                                    : <>
                                                        <DataSection />
                                                        <Button type="YELLOW" onClick={handleSignMessage} iconSrc={walletIcon}>
                                                            Sign a Message
                                                        </Button>
                                                    </>
                                            }

                                        </Col>
                                }

                            </span>
                        </Col>

                    ) : (
                        ""
                    )}
            </div>
        </Container>

    )
}